export default class Group
{
  constructor(name) 
  {
    this.name = name;
  }    

  isValid()
  {
    return Boolean(this.name);
  }
}